import * as React from "react";
import { Redirect } from "react-router-dom";
import { CalendarState, PrintInfo } from "burde";
import {
    CalendarType,
    CoverImageDrawWidth,
    CoverImageDrawHeight,
} from "svg/constants";
import { DefaultSize, CalendarSteps } from "ui/constants";
import { getCalendarThemes } from "content/theme/service";
import { getCalendarStateFromPrintInfo } from "ui/helper";
import { ZentaThemePicker, Theme } from "content/theme";
import { AdminHeader } from "page/admin/admin-header";

interface ThemesListProps {
    setActiveCalendar: (calendar?: CalendarState) => any;
    Admin_Dashboard_Themes: string;
}

interface ThemesListState {
    themes: Array<PrintInfo>;
    openCalendar: boolean;
    sizeName: string;
}

class ThemesList extends React.Component<ThemesListProps, ThemesListState> {
    state: ThemesListState = {
        themes: [],
        openCalendar: false,
        sizeName: DefaultSize,
    };

    private selectTheme = async (theme: Theme | null) => {
        const { themes } = this.state;

        const pickedTheme = theme
            ? themes.find((t) => t.calendarId === theme.id)
            : undefined;

        if (pickedTheme) {
            const calendarState = getCalendarStateFromPrintInfo(pickedTheme);
            await this.props.setActiveCalendar({
                ...calendarState,
                isTheme: true,
            });

            this.setState({
                sizeName:
                    calendarState.calendarSize &&
                    calendarState.calendarSize != ""
                        ? calendarState.calendarSize
                        : DefaultSize,
            });
        } else {
            this.props.setActiveCalendar();
        }

        this.setState({
            openCalendar: true,
        });
    };

    private fetchThemes = async () => {
        const themes = await getCalendarThemes();

        if (!themes) {
            return;
        }

        this.setState({
            themes,
        });
    };

    componentDidMount() {
        this.fetchThemes();
    }

    render() {
        const { themes, openCalendar, sizeName } = this.state;

        let calendarSize = sizeName !== undefined ? sizeName : DefaultSize;

        if (openCalendar) {
            return (
                <Redirect
                    to={`/calendar/${calendarSize.toLowerCase()}/${
                        CalendarSteps.insert
                    }`}
                    push
                />
            );
        }

        return (
            <div className={"container mt-4"}>
                <AdminHeader title={this.props.Admin_Dashboard_Themes} />

                <ZentaThemePicker
                    withAdminPanel
                    selectedTheme={null}
                    themes={themes.map((t) => ({
                        id: t.calendarId,
                        name: t.name,
                        url: t.cover.customImage
                            ? t.cover.customImage.url
                            : t.cover.image
                            ? `/images/cover/${t.cover.image}?width=${CoverImageDrawWidth}&height=${CoverImageDrawHeight}`
                            : null,
                        color: t.cover.color,
                        published: true,
                    }))}
                    onClick={this.selectTheme}
                    onUpdate={this.fetchThemes}
                />
            </div>
        );
    }
}

export default ThemesList;
